/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Module for Custom Rep/Covering Cell.
 * @module src/Events/EventsList
 */
import React, { FC, useEffect, useState, useCallback, useMemo } from 'react';
import { useMutation } from '@apollo/react-hooks';
import { useSelector } from 'react-redux';
import DataTableCell from '@salesforce/design-system-react/components/data-table/cell';
import Input from '@salesforce/design-system-react/components/input';
import CREATE_UPDATE_CYCLE_COUNT_LINE_ITEMS from '../../../../graphql/mutations/createUpdateCycleCountLineItems';
import debounced from '../../../../util/debounced';
import { getUserInfo } from '../../../../store/ducks/userInfo';
import { NOTIFY_TYPE, SYSTEM_NAME ,DEFAULT_VERSION} from '../../../../util/constants';
import { CycleCountDetails } from '../types';

interface Quantity {
  quantity: string;
  availablequantity: string;
  productdescription: string;
  cycleCountId: string;
  cycleCountExternalId: string;
  createdByDetails: any[];
  lotNumber: string;
  createdBy: string;
  id: string;
  isOpen: boolean;
  needToDisplay: boolean;
  isManual: boolean;
  externalId: string;
  productNumber: string;
  productId: string;
}
interface Props {
  item?: Quantity;
  handleRefetchLineItems?: (action: any) => void;
  cycleCountDetails: CycleCountDetails;
  isOps?: boolean;
  inProgress?: boolean;
  disabled?: boolean;
  displaySnackBar?: (type: string, message: string) => void;
}

const TableRowCell: FC<Props> = ({
  item = {
    quantity: '',
    availablequantity: '',
    productdescription: '',
    createdBy: '',
    createdByDetails: [],
    cycleCountId: '',
    cycleCountExternalId: '',
    lotNumber: '',
    id: '',
    isOpen: false,
    needToDisplay: false,
    isManual: false,
    externalId: '',
    productNumber: '',
    productId: '',
  },
  isOps,
  inProgress,
  handleRefetchLineItems,
  cycleCountDetails,
  disabled,
  displaySnackBar,
}) => {
  const {
    createdByDetails,
    lotNumber,
    cycleCountId,
    cycleCountExternalId,
    isOpen,
    needToDisplay,
    createdBy,
    externalId,
    productNumber,
    productId,
  } = item;
  const [lotValue, setLotValue] = useState<string>(
    createdByDetails[0]?.lotNumber?.toUpperCase() || ''
  );
  const [createUpdateCycleCountLineItems, { data: eventUsageMutation }] = useMutation(
    CREATE_UPDATE_CYCLE_COUNT_LINE_ITEMS
  );
  const userInfo = useSelector(getUserInfo);

  // Sync local state when prop changes (e.g., after mutation succeeds and data refetches)
  useEffect(() => {
    setLotValue(createdByDetails[0]?.lotNumber?.toUpperCase() || '');
  }, [createdByDetails]);

  useEffect(() => {
    if (
      eventUsageMutation &&
      eventUsageMutation.createUpdateCycleCountLineItems &&
      eventUsageMutation.createUpdateCycleCountLineItems.message === 'success'
    )
      if (handleRefetchLineItems) {
        handleRefetchLineItems('update');
      }
  }, [eventUsageMutation, handleRefetchLineItems]);

  const setUpdate = useCallback((mutation: any): void => {
    if (mutation) {
      createUpdateCycleCountLineItems({
        variables: mutation,
      });
    }
  }, [createUpdateCycleCountLineItems]);

  const debouncedFetchItems = useMemo(() => debounced(200, setUpdate), [setUpdate]);

  const isEmptyLot = (lot: string | null | undefined): boolean => !lot || lot.trim() === '';

  const UpdateLineItems = (event: any, lineid: string, extId: string): void => {
    const payload: Array<any> = [];
    const newLotNumber = event.target.value?.trim().toUpperCase();
    const originalLotNumber = createdByDetails[0]?.lotNumber?.trim().toUpperCase() || '';

    if (newLotNumber === originalLotNumber) {
      return;
    }

    const currentProductId = createdByDetails[0]?.productId;
    const currentUserId = userInfo?.id;

    const hasDuplicateForCurrentUser = cycleCountDetails.lineItems.some(lineItem => {
      if (lineItem.productId !== currentProductId) return false;
      return lineItem.createdByDetails?.some((detail: any) => {
        if (detail.createdById !== currentUserId) return false;
        if (detail.externalId === extId) return false;
        if (isEmptyLot(newLotNumber) && isEmptyLot(detail.lotNumber)) return true;
        return detail.lotNumber?.trim().toUpperCase() === newLotNumber;
      });
    });

    if (hasDuplicateForCurrentUser) {
      if (displaySnackBar) {
        const lotDisplay = isEmptyLot(newLotNumber) ? '(empty)' : newLotNumber;
        displaySnackBar(NOTIFY_TYPE.ERROR, `You already have this product with Lot ${lotDisplay}`);
      }
      setLotValue(lotNumber?.toUpperCase() || '');
      return;
    }

    createdByDetails?.forEach((i: any): void => {
      if (i.externalId === extId) {
        const newLotValue = event.target.value?.trim().toUpperCase();
        payload.push({
          sfid: lineid,
          externalId: extId,
          lotNumber: newLotValue || null,
          quantity: i.quantity,
          productNumber,
          productId,
        });
        const mutation = {
          cycleCountExternalId: cycleCountExternalId || cycleCountDetails?.cycleCountExternalId,
          cycleCountId: cycleCountId || cycleCountDetails?.cycleCountId,
          formType: 'New',
          lineItems: payload,
          countType: 'Blind',
          system: SYSTEM_NAME,
          version: process.env.REACT_APP_VERSION || DEFAULT_VERSION,
        };
        debouncedFetchItems(mutation);
      }
    });
  };

  return needToDisplay ? (
    <DataTableCell
      title={lotNumber || 'enter lot number'}
      className={`${isOps ? 'lotNumber' : 'center-align'}`}
      key={externalId}
    >
      {(createdByDetails &&
        isOps &&
        createdByDetails[0]?.createdByPersona?.toLowerCase().includes('branch op')) ||
      (!isOps && cycleCountDetails?.status?.toLowerCase() === 'in progress') ? (
        <Input
          value={lotValue}
          onChange={(event: any): void => {
            setLotValue(event.target.value.toUpperCase());
          }}
          onBlur={(_event: any): void =>
            UpdateLineItems(_event, createdByDetails[0]?.sfid, createdByDetails[0]?.externalId)
          }
          id="unique-id-4"
          disabled={
            !!(
              (cycleCountDetails &&
                (cycleCountDetails.status.toLowerCase() === 'cancelled' ||
                  cycleCountDetails.status.toLowerCase() === 'completed')) ||
              disabled ||
              (!isOps && createdBy !== userInfo?.id) ||
              (!item?.isManual && createdByDetails[0]?.lotNumber)
            )
          }
        />
      ) : (
        lotNumber?.toUpperCase()
      )}
      {isOpen &&
        createdByDetails?.map((lineItem: any) => (
          <div className="border-line">
            <DataTableCell>{lineItem.createdByName}</DataTableCell>
          </div>
        ))}
    </DataTableCell>
  ) : null;
};

/** Custom Rep/Covering cell */
export default TableRowCell;
